import { faChevronDown, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { FormGroup } from 'reactstrap';
import { Popover as AntdPopover, Switch } from 'antd';
import { OtsideClickClosingWrapper } from '../../common/EmojiReactionPicker/OtsideClickClosingWrapper';
import { GroupByButton } from './GroupByButton';
import './GroupByButton';
export default function GetElementsGroupBy({groupByFilter, setGroupFilter, taskFilterSetting, setTaskFilterSetting }) {
  const itemsTaskGroup = [
    { name: "All Tasks", value: "All Tasks", type: "string", sortOrder: "asc" },
    { name: "Pipeline (Position)", value: "PipelineROWID", type: "string", sortOrder: "asc" },
    { name: "Pipeline (Name)", value: "PipelineROWID", type: "string", sortOrder: "asc" },
    { name: "Status", value: "TaskStatus", type: "string", sortOrder: "asc" },
    { name: "Assignee", value: "Assignee", type: "string", sortOrder: "asc" },
    { name: "Priority", value: "Priority", type: "string", sortOrder: "asc" },
    { name: "Project Manager", value: "Supervisor", type: "string", sortOrder: "asc" },
    { name: "Due Date", value: "DueDate", type: "date", sortOrder: "asc" },
  ];
  const itemDealGroup = [
    { name: "All Deals", value: "None", type: "string", sortOrder: "asc" },
    { name: "Status", value: "Stage", type: "string", sortOrder: "asc" },
    { name: "Deal Name", value: "Deal_Name", type: "string", sortOrder: "desc" },
    {
      name: "Accounts", isNested: true, value: "Accounts", type: "string", sortOrder: "asc", getValue: (data) => {
        if (data?.Client?.id) {
          return data["Client"]["id"]
        } else {
          return "Unknown"
        }
      }
    },
    { name: "Closing Date", value: "Closing_Date", type: "date", sortOrder: "asc" },
    { name: "NYC Project", value: " Is_NYC_Project", type: "string" , sortOrder: "asc"},
    { name: "Borough", value: "Borough", type: "string", sortOrder: "asc" }, 
  ];  
  const [isOpen, setIsOpen] = useState(false);
  const [tempGroupBy, setTempGroupBy] = useState({ ...groupByFilter });
  const [allCollapsed, setAllCollapsed] = useState(true);
    // console.log(".................",groupByFilter);
  useEffect(()=>{
    setTempGroupBy({...groupByFilter})
  },[groupByFilter])
    const getSearchBox = (module) => {
        return <FormGroup className="group-by-search" style={{ position: 'relative' }} >
            
            <FontAwesomeIcon
                className="mr-sm-2 search-ico"
                icon={faSearch}
            />
        </FormGroup>
    }
    const changeGroupBy = (data, key) => {
        let obj = { ...tempGroupBy };
        obj[key] = data;
        setTempGroupBy(obj)
    }
    const changeSortOrder = (order, key) => {
      setTempGroupBy(prev => ({
        ...prev,
        [key]: {
          ...prev[key],
          sortOrder: order,
        }
      }));
    };
    const getElement = () => {
        return (<> 
            <AntdPopover
                style={{ height: 300, width : "700px" }}
                placement="bottomLeft"
                trigger="click"
                overlayClassName="group-by-popover"
                open={isOpen}
                content={<OtsideClickClosingWrapper
                    className="group-by-tasklist"
                    close={e => {
                        setIsOpen(false);
                    }}
                >
              <div className="group-by-container" onClick={(e) => e.stopPropagation()}>
                <div className="group-by-header">GROUP BY</div>

                {/* DEAL DROPDOWN */}
                <div className="group-by-row" onClick={(e) => e.stopPropagation()}>
                  <select
                    className="group-by-select"
                    value={tempGroupBy?.group1?.name}
                    placeholder='Please Select Value'
                    onChange={(e) => {
                      const selected = itemDealGroup.find(x => x.name === e.target.value);
                      changeGroupBy(selected, 'group1');
                    }}
                  >
                    {itemDealGroup?.map((one) => (
                      <option key={one.name} value={one.name}>
                        {one.name}
                      </option>
                    ))}
                  </select>
                  <div className="group-by-toggle">
                    <button
                      className={tempGroupBy.group1.sortOrder === "asc" ? "active" : ""}
                      onClick={() => changeSortOrder("asc", "group1")}
                    >
                      {tempGroupBy?.group1?.type === "date" || tempGroupBy?.group1?.type === "number" ? "1 → 9" : "A -> Z" } 
                    </button>
                    <button
                      className={tempGroupBy.group1.sortOrder === "desc" ? "active" : ""}
                      onClick={() => changeSortOrder("desc", "group1")}
                    >
                      {tempGroupBy?.group1?.type === "date" || tempGroupBy?.group1?.type === "number" ? "9 → 1" : "Z -> A" }
                    </button>
                  </div>
                </div>

                {/* TASK DROPDOWN */}
                <div className="group-by-row" onClick={(e) => e.stopPropagation()}>
                  <select
                    className="group-by-select"
                    value={tempGroupBy?.group2?.name}
                    placeholder='Please Select Value'
                    onChange={(e) => {
                      const selected = itemsTaskGroup.find(x => x.name === e.target.value);
                      changeGroupBy(selected, 'group2');
                    }}
                  >
                    {itemsTaskGroup?.map((one) => (
                      <option key={one.name} value={one.name}>
                        {one.name}
                      </option>
                    ))}
                  </select>
                  <div className="group-by-toggle">
                    <button
                        className={tempGroupBy.group2.sortOrder === "asc" ? "active" : ""}
                        onClick={() => changeSortOrder("asc", "group2")}
                      >
                        {tempGroupBy?.group2?.type === "date" || tempGroupBy?.group2?.type === "number" ? "1 → 9" : "A -> Z" } 
                      </button>
                      <button
                        className={tempGroupBy.group2.sortOrder === "desc" ? "active" : ""}
                        onClick={() => changeSortOrder("desc", "group2")}
                      >
                        {tempGroupBy?.group2?.type === "date" || tempGroupBy?.group2?.type === "number" ? "9 → 1" : "Z -> A" }
                      </button>
                  </div>
                </div>

                {/* FOOTER */}
                  <div style={{display: 'flex', flexDirection: "column", gap: "12px", padding: '10px 1px 0px ', fontWeight: '500', color: '#767676'}}>
                    <div className='group-by-footer' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                      <span style={{marginRight: "10px"}}>Collapse Deal Group</span>
                      <Switch
                        style={{width:'3.2rem', backgroundColor: '#bfbfbf'}}
                        onChange={(checked, event) => {
                        const obj = { ...taskFilterSetting };
                        if (checked) {
                            obj["ExpandDeals"] = checked;
                          } else {
                            obj["ExpandDeals"] = checked;
                            obj["ExpandGroups"] = false;
                            obj["ExpandTasks"] = false;
                        }
                        setTaskFilterSetting(obj);
                        }}     
                        size="small"
                        checked={taskFilterSetting.ExpandDeals}
                      />
                    </div>
                    <div className='group-by-footer' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                      <span style={{marginRight: "10px"}}>Collapse Task Group</span>
                      <Switch
                        style={{width:'3.2rem', backgroundColor: '#bfbfbf'}}
                        onChange={(checked, event) => {
                        const obj = { ...taskFilterSetting };
                        if (checked) {
                            obj["ExpandGroups"] = true;
                            obj["ExpandDeals"] = true;
                        } else {
                            obj["ExpandGroups"] = checked;
                            obj["ExpandTasks"] = checked;
                        }
                        setTaskFilterSetting(obj);
                        }}     
                        size="small"
                        checked={taskFilterSetting.ExpandGroups}
                      />
                    </div>
                    <div className='group-by-footer' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                      <span style={{marginRight: "10px"}}>Collapse All</span>
                      <Switch
                        style={{width:'3.2rem', backgroundColor: '#bfbfbf'}}
                        onChange={(checked, event) => {
                        const obj = { ...taskFilterSetting };
                        if (checked) {
                            obj["ExpandTasks"] = checked;
                            obj["ExpandGroups"] = true;
                            obj["ExpandDeals"] = true;
                        } else {
                            obj["ExpandTasks"] = checked;
                        }
                        setTaskFilterSetting(obj);
                        }}     
                        size="small"
                        checked={taskFilterSetting.ExpandTasks}
                      />
                    </div>
                    <div style={{display: "flex", justifyContent: "flex-end"}}>
                      <span
                          className="apply-btn"
                          onClick={() => {
                              setIsOpen(false);
                              setGroupFilter(tempGroupBy);
                          }}
                      >
                        Apply
                      </span>
                    </div>
                  </div>
              </div>
            </OtsideClickClosingWrapper>
          }
        >
          <GroupByButton onClick={() => setIsOpen(!isOpen)} />
        </AntdPopover>
      </>
    );
  };

  return <div onClick={() => setIsOpen(!isOpen)}>{getElement()}</div>;
}
